import React from "react";
import LegalLayout, { Section, COMPANY } from "./LegalLayout";

export default function PrivacyPolicy() {
  return (
    <LegalLayout title="Política de Privacidade" subtitle="RGPD">
      <p className="text-sm text-muted-foreground/80">Última atualização: {new Date().toLocaleDateString("pt-PT")}</p>

      <Section n="1" title="Responsável pelo tratamento">
        <p>O responsável pelo tratamento dos seus dados pessoais é a <strong className="text-foreground">{COMPANY.legalName}</strong> ({COMPANY.name}), com sede na {COMPANY.address}, NIF/NIPC {COMPANY.nif}.</p>
        <p>Contactos: {COMPANY.email} · {COMPANY.phone}.</p>
      </Section>

      <Section n="2" title="Que dados recolhemos">
        <p>Este site é essencialmente informativo (catálogo de viaturas). Podemos tratar os seguintes dados:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>Dados de contacto que nos fornecer voluntariamente ao contactar-nos por telefone, email ou WhatsApp (nome, número, email e conteúdo da mensagem).</li>
          <li>Dados técnicos estritamente necessários ao funcionamento do site, incluindo um cookie de sessão utilizado apenas na área de administração.</li>
        </ul>
        <p>Não recolhemos dados sensíveis nem realizamos decisões automatizadas ou definição de perfis.</p>
      </Section>

      <Section n="3" title="Finalidades e base legal">
        <ul className="list-disc pl-5 space-y-1">
          <li>Responder a pedidos de informação sobre viaturas — base legal: diligências pré-contratuais/interesse legítimo (art. 6.º, n.º 1, al. b) e f) do RGPD).</li>
          <li>Garantir o funcionamento e segurança do site — base legal: interesse legítimo (art. 6.º, n.º 1, al. f)).</li>
          <li>Cumprir obrigações legais aplicáveis à atividade — base legal: al. c).</li>
        </ul>
      </Section>

      <Section n="4" title="Prazo de conservação">
        <p>Os dados são conservados apenas durante o tempo necessário às finalidades acima ou pelos prazos legais aplicáveis, sendo depois eliminados de forma segura.</p>
      </Section>

      <Section n="5" title="Partilha de dados">
        <p>Não vendemos os seus dados. Poderão ser tratados por prestadores de serviços técnicos (por exemplo, alojamento do site) que atuam por nossa conta e sob obrigações de confidencialidade.</p>
      </Section>

      <Section n="6" title="Os seus direitos">
        <p>Pode exercer, a qualquer momento, os direitos de acesso, retificação, apagamento, limitação, oposição e portabilidade, contactando-nos para {COMPANY.email}.</p>
        <p>Tem ainda o direito de apresentar reclamação junto da autoridade de controlo — a <strong className="text-foreground">Comissão Nacional de Proteção de Dados (CNPD)</strong>, através de <a href="https://www.cnpd.pt" target="_blank" rel="noopener noreferrer" className="text-primary underline underline-offset-2">www.cnpd.pt</a>.</p>
      </Section>

      <Section n="7" title="Cookies">
        <p>Utilizamos apenas cookies estritamente necessários ao funcionamento do site (nomeadamente para manter a sessão de administração). Estes cookies não requerem consentimento prévio nos termos da lei. Não utilizamos cookies de publicidade ou de rastreio de terceiros.</p>
      </Section>
    </LegalLayout>
  );
}
